import * as React from 'react';
import { TaxData } from '../../types/location';
import Loader from '../elements/Loader';
import classNames from 'classnames';
import { DeleteTaxRateByIdMutation } from '../../mutations/TaxRatesMutations';
interface EditTaxRatesDropdownProps {
  setOpenEditModal: React.Dispatch<
    React.SetStateAction<{
      [key: number]: TaxData;
    }>
  >;
  handleAddMinOrMaxPrice: (
    index: number,
    applicableKey: 'min_applicable' | 'max_applicable',
  ) => void;
  setModalOpen: React.Dispatch<
    React.SetStateAction<{
      [key: number]: boolean;
    }>
  >;
  minPrice?: boolean;
  maxPrice?: boolean;
  tax: TaxData;
  partnerId: string;
  index: number;
}
const EditTaxRatesDropdown = ({
  handleAddMinOrMaxPrice,
  setOpenEditModal,
  setModalOpen,
  index,
  tax,
  partnerId,
  minPrice,
  maxPrice,
}: EditTaxRatesDropdownProps) => {
  const deleteTaxRate = DeleteTaxRateByIdMutation({
    id: tax.id,
    partnerId,
    setOpen: setModalOpen,
  });

  const onSubmit = () => {
    deleteTaxRate.mutate();
  };

  return (
    <div className='w-[155px] h-fit border border-gray-300 rounded-md flex-col'>
      <div
        className='h-11 w-full flex pl-[20px] items-center cursor-pointer rounded-t-md hover:bg-gray-100'
        onClick={() => {
          setOpenEditModal(() => ({
            [index]: tax,
          }));
        }}
      >
        <p>Edit Tax Rate</p>
      </div>
      <div
        className='h-11 w-full flex pl-[20px] items-center cursor-pointer hover:bg-gray-100'
        onClick={() => {
          handleAddMinOrMaxPrice(index, 'min_applicable');
        }}
      >
        <p>{!minPrice ? 'Add' : 'Delete'} Min Price</p>
      </div>
      <div
        className='h-11 w-full flex pl-[20px] items-center cursor-pointer hover:bg-gray-100'
        onClick={() => {
          handleAddMinOrMaxPrice(index, 'max_applicable');
        }}
      >
        <p>{!maxPrice ? 'Add' : 'Delete'} Max Price</p>
      </div>
      {/* Hide the ability to delete tax rates until evaluation is performed in EO-113 */}
      <div
        className={classNames(
          'h-11 w-full pl-[20px] items-center cursor-pointer hover:bg-gray-100 rounded-b-md hidden',
          {
            'text-gray-500': deleteTaxRate.isPending,
          },
        )}
        onClick={!deleteTaxRate.isPending ? onSubmit : undefined}
        data-test-id='delete-tax-rate'
      >
        <p>Delete Tax Rate</p>
        {deleteTaxRate.isPending && (
          <div className='ml-2'>
            <Loader fillColor='#6923F4' size='15px' />
          </div>
        )}
      </div>
    </div>
  );
};
export default EditTaxRatesDropdown;
